import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TrucksTableFooterProps = {
  shiftTotal?: number;
  currentHourLabel: string;
  currentHourSum?: number;
  isLoading: boolean;
};

const TrucksTableFooter: React.FC<TrucksTableFooterProps> = ({
  shiftTotal,
  currentHourLabel,
  currentHourSum,
  isLoading
}) => {
  return (
    <div className="w-full pt-2 flex flex-wrap justify-end items-center gap-6 animate-fade-up text-2xl border-t border-theme-border">
      <span className="text-theme-text flex items-center">
        Total Truck Loads:
        <span className="flex items-center justify-center font-bold bg-theme-warning rounded px-3 py-1 ml-3 min-w-[4rem] min-h-[2.5rem]">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            className={`text-3xl text-theme-text transition ease-out absolute ${isLoading ? "opacity-100" : "opacity-0 "}`}
          />
          <span className={`transition ease-out ${isLoading ? "opacity-0" : "opacity-100"}`}>{shiftTotal}</span>
        </span>
      </span>

      <span className="text-theme-text flex items-center">
        {currentHourLabel}:
        <span className="flex items-center justify-center font-bold bg-theme-warning rounded px-3 py-1 ml-3 min-w-[4rem] ">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            className={`text-3xl text-theme-text transition ease-out absolute ${isLoading ? "opacity-100" : "opacity-0"}`}
          />
          <span className={`transition ease-out ${isLoading ? "opacity-0" : "opacity-100"}`}>{currentHourSum}</span>
        </span>
      </span>
    </div>
  )
};

export default TrucksTableFooter;